// extracted by mini-css-extract-plugin
export default {"modalImg":"ModalWindows_modalImg__0yehi","bottomBtn":"ModalWindows_bottomBtn__ApcRo","btn":"ModalWindows_btn__R7Z03"};